// A command on one row: coloured shell code and a Copy button. Wraps instead of clipping, so the whole command is always visible.

import { useState } from 'react';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import { Button } from './Button';
import { ShellCode } from './ShellCode';

export function CopyButton({ text, testid = 'cli-copy-install' }: { text: string; testid?: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <Button
      size="sm"
      variant="ghost"
      icon={copied ? <IconCheck size={16} stroke={1.5} aria-hidden /> : <IconCopy size={16} stroke={1.5} aria-hidden />}
      onClick={() => {
        void navigator.clipboard?.writeText(text).then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 1500);
        });
      }}
      data-testid={testid}
    >
      {copied ? 'Copied' : 'Copy'}
    </Button>
  );
}

export function CodeRow({
  text,
  className = 'cli-cmd',
  codeTestid,
  copyTestid,
}: {
  text: string;
  /** cli-cmd (account, guide) or hx-start-cmd (the Start window). */
  className?: 'cli-cmd' | 'hx-start-cmd';
  codeTestid?: string;
  copyTestid?: string;
}) {
  return (
    <span className={className}>
      <code data-testid={codeTestid}>
        <ShellCode>{text}</ShellCode>
      </code>
      <CopyButton text={text} testid={copyTestid} />
    </span>
  );
}
